export default __webpack_public_path__ + "static/media/male-average.a5dc835f.webp";